export enum Permission {
  FmHmAcl = "FmHmAcl",
  FmAgent = "FmAgent",
  ExecInsightsApp = "ExecInsightsApp",
  CompanyBuilderApp = "CompanyBuilderApp",
  PathwaysApp = "PathwaysApp",
  PeopleListLibraryApp = "PeopleListLibraryApp",
  BdPortalApp = "BdPortalApp",
  FmExecBetaApps = "FmExecBetaApps",
  FmExecDevApps = "FmExecDevApps",
  FmCrmApp = "FmCRM"
}
